import * as React from 'react'
import { Row, Col } from 'components/Layout'
import { Form, Field, InjectedFormProps, FieldArray } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { IContactClientForm } from 'features/Contacts/types'
import FieldArrayRows from 'components/Input/FieldArrayRows'
import InfoCard from 'components/Cards/InfoCard'

import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sMarg from 'styles/modules/margins.scss'
import * as sText from 'components/Text/Text.scss'
import { formToContact } from 'features/Contacts/utils'
import { useContactUpdateMutation } from 'src/generated/graphql'

const ArrayPhoneValueField = props => (
  <Field component={Input} label="Phone Number" validate={[vRequired]} {...props} />
)

const ArrayTagValueField = props => (
  <Field component={Input} label="Tag" validate={[vRequired]} {...props} />
)

const ArrayKeyValueField = props => (
  <div className={sLay['layout-row']}>
    <div className={sLay['flex-50']}>
      <Field
        component={Input}
        name={`${props.name}.key`}
        label="Identifier"
        validate={[vRequired]}
      />
    </div>
    <div className={sLay['flex-50']} style={{ marginLeft: '5px' }}>
      <Field component={Input} name={`${props.name}.value`} label="Value" validate={[vRequired]} />
    </div>
  </div>
)

export type IContactsListComponentProps = InjectedFormProps<IContactClientForm>

export const ContactEditComponent = (props: IContactsListComponentProps) => {
  const { submitting, handleSubmit } = props
  const [contactUpdate] = useContactUpdateMutation()

  return (
    <Form onSubmit={handleSubmit(data => contactUpdate({ variables: formToContact(data) }))}>
      <InfoCard title="Contact Number" className={sMarg.mb30to15}>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Add 1 or more contact number. If you add more than 1, they will be prioritised from top to
          bottom.
        </div>
        <FieldArray
          name="phoneNumbers"
          FieldComponent={ArrayPhoneValueField}
          component={FieldArrayRows}
          validate={[vRequired]}
          info="Including, +, country and area code"
          addText="Add number"
        />
      </InfoCard>
      <InfoCard title="Contact Details" className={sMarg.mb30to15}>
        <Row className={cn(sLay['layout-row'], 'sm')}>
          <Col className={cn(sLay['flex-50'], 'sm')}>
            <Field name="firstName" label="First name" component={Input} />
          </Col>
          <Col className={cn(sLay['flex-50'], 'sm')}>
            <Field name="lastName" label="Last name" component={Input} />
          </Col>
        </Row>
        <Field name="company" label="Company" component={Input} />
        <Field name="email" label="Email" component={Input} />
        <Field
          name="userId"
          label="User ID"
          component={Input}
          info="A unique identifier for the user in your database"
        />
      </InfoCard>
      <InfoCard title="Tags" className={sMarg.mb30to15}>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Add custom tags here. You can design flows that trigger when these tags are added or
          removed.
        </div>
        <FieldArray
          name="tags"
          FieldComponent={ArrayTagValueField}
          component={FieldArrayRows}
          addText="Add tag"
          dontInitialise
        />
      </InfoCard>
      <InfoCard title="Custom Fields" className={sMarg.mb30to15}>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          Optionally, add your own custom fields to this contact. This data will then be available
          in your flows as a variable.
        </div>
        <FieldArray
          name="customFields"
          FieldComponent={ArrayKeyValueField}
          component={FieldArrayRows}
          addText="Add custom data"
          dontInitialise
        />
      </InfoCard>
      <br />
      <Button
        color="tertiary"
        loading={submitting}
        type="submit"
        size="lg"
        rect
        className={cn(sMarg.w100xs, sMarg.mb15xs)}
      >
        Save
      </Button>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactEdit/ContactEdit.tsx